/**
 * @generated SignedSource<<a8b4feba196065181e10d044f3ef3b73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNotePageBackground_widgetNotePage$data = {
  readonly backgroundColor: string | null;
  readonly image: {
    readonly id: string;
    readonly largeImage: {
      readonly height: number;
      readonly url: string;
      readonly width: number;
    } | null;
  } | null;
  readonly imageScale: number | null;
  readonly imageTranslateX: number | null;
  readonly imageTranslateY: number | null;
  readonly " $fragmentType": "WidgetNotePageBackground_widgetNotePage";
};
export type WidgetNotePageBackground_widgetNotePage$key = {
  readonly " $data"?: WidgetNotePageBackground_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackground_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNotePageBackground_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "largeImage",
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 1080
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 1080
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": "size(minHeight:1080,minWidth:1080)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageScale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageTranslateX",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageTranslateY",
      "storageKey": null
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "f09135f55a16e1663965825d768f0d8c";

export default node;
